<!-- components/BudgetInput.vue -->
<template>
  <div class="budget-input">
    <el-input-number
        v-model="budgetValue"
        :min="minBudget"
        :step="step"
        :disabled="disabled"
        :placeholder="placeholder"
        @change="handleChange"
    />
    <span class="unit">分</span>
    <span class="hint">（{{ yuanValue }} 元）</span>
  </div>
</template>

<script>
export default {
  name: 'BudgetInput',
  props: {
    value: {
      type: Number,
      default: null
    },
    minBudget: {
      type: Number,
      default: 5000  // 最小50元
    },
    step: {
      type: Number,
      default: 1000
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请输入预算'
    }
  },
  data() {
    return {
      budgetValue: this.value
    }
  },
  computed: {
    yuanValue() {
      if (this.budgetValue === null || this.budgetValue === undefined) {
        return '0.00'
      }
      return (this.budgetValue / 100).toFixed(2)
    }
  },
  watch: {
    value(val) {
      this.budgetValue = val
    }
  },
  methods: {
    handleChange(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style scoped>
.budget-input {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.unit {
  font-size: 12px;
  color: #909399;
}

.hint {
  font-size: 12px;
  color: #c0c4cc;
}
</style>